const live = {}// 直播, 点播
const test = {}// 浏览记录、疫病检测列表/某一套检测题
const json = {}// 牧场静态数据
const news = {}// 兽医头条
const reg = {}// 中科基因注册
const join = {}// 加入我们信息
const chat = {}// 中科基因聊天历史
const expert = {} // 专家详情
const expertreg = {} // 专家注册
const login = {} // 登录注册
const inovice = {} // 发票
const index = {} // 首页中科名兽医信息
const talk = {} // 话题详情
const qzyz = {} // 禽智养殖
// const apijson = '/json/'// 本地使用l
let api
let apis
let apin
let apijson
let appkey
let wechaturl
let apil
let apiUrl = 'app2.sslab.com.cn'
if (apiUrl.includes('app2.sslab.com.cn')) {
  api = 'https://app2.sslab.com.cn'
  apis = 'https://api.sslab.com.cn'
  apin = 'https://ncapi.sslab.com.cn'
  apijson = '../zkmsy/json'
  appkey = 'pwe86ga5pv336'
  apil = 'http://bj-lims.sslab.com.cn'
  wechaturl = 'http://app2.sslab.com.cn/zkmsy/index.html#/'
} else {
  // api = 'http://59.110.167.93'
  api = 'https://xcxtest.sslab.com.cn'
  apis = 'https://testapi.sslab.com.cn'
  apin = 'https://ncapitest.sslab.com.cn'
  apil = 'http://testbj-lims.sslab.com.cn'
  // apin = 'http://api.sslab.com.cn/'
  apijson = '../zkmsytest/json'
  appkey = 'ik1qhw09ipccp'
  wechaturl = 'http://app2.sslab.com.cn/zkmsytest/index.html#/'
}
// let shareUrl = encodeURIComponent(window.location.href.split('#')[0]);
// console.log('shareUrl',shareUrl)
if (window.location.host !== 'app2.sslab.com.cn') {
  apijson = '../json'
}
// 获取短信验证码
login.getclassList = { url: '/api/BI/report/epidemic/classList', method: 'post' }
// const apimap = 'http://' + window.location.host // 本地使用
// console.log('apimap',apimap)
// 静态牧场选择题
json.pasture = { url: apijson + '/pasture.json', method: 'getjson' }
// 静态实验室选择题
json.laboratory = { url: apijson + '/laboratory.json', method: 'getjson' }

// 获取短信验证码
login.getUserSendCode = { url: apis + '/sso/user/common/sendCode', method: 'post' }
// 中科名兽医手机登录
login.zkmsyPhonelogin = { url: apis + '/sso/zkmsyUser/common/zkmsyPhonelogin', method: 'post' }
// 获取用户信息
login.getUserInfo = { url: apis + '/custer/user/getUserInfo', method: 'postlogin' }

// 获取直播视频详情
live.getLiveDetail = { url: apis + '/zkmsyApi/live/common/detail/h5', method: 'post' }
// 统计分享次数
live.getLiveShareInc = { url: apis + '/zkmsyApi/live/common/share/inc', method: 'post' }
// 获取分享列表
live.getLiveShareList = { url: apis + '/zkmsyApi/live/common/share/list', method: 'post' }
// 查询直播状态
live.getLiveStatus = { url: apis + '/zkmsyApi/live/common/status', method: 'post' }
// 获取直播视频
live.sharevideolive = { url: api + '/education/roominfo/2.0.2/', method: 'post' }
// 直播断流获取数据
live.getendtime = { url: api + '/education/getendtime/', method: 'post' }
// 获取点播视频
live.sharevideoinfo = { url: api + '/education/sharevideoinfo/', method: 'get' }

// 浏览记录
test.getaccessstatus = { url: api + '/disease/getaccessstatus', method: 'get' }
// 疫病检测某一套检测题目
test.diseaseexam = { url: api + '/disease/diseaseexam/', method: 'get' }
// 提交疫病检测列表检测题
test.answerdisease = { url: api + '/disease/answerdisease/', method: 'post' }
// 牧场选择题结果
test.farmanswer = { url: api + '/disease/farmanswer/', method: 'postfomdata' }
// 实验室选择题结果
test.labbiosafetyeval = { url: api + '/disease/labbiosafetyeval/', method: 'postfomdata' }
// 伪狂犬病净化结果
test.getresults = { url: api + '/disease/getresults/', method: 'postfomdata' }

// 兽医头条
news.newsdetail = { url: api + '/education/newsdetailrendering/', method: 'get' }
news.pigLog = { url: api + '/disease/pig_log/', method: 'get' }
news.allPrice = { url: api + '/disease/all_price/', method: 'postfomdata' }
news.getProvince = { url: api + '/disease/get_province/', method: 'get' }

// 排行
news.rankList = { url: apis + '/zkmsyApi/pig/price/rankList', method: 'get' }
news.priceshow = { url: apis + '/zkmsyApi/pig/price/priceshow', method: 'get' }
news.getdict = { url: apis + '/zkmsyApi/pig/price/getdict', method: 'get' }
news.priceline = { url: apis + '/zkmsyApi/pig/price/priceline', method: 'get' }
news.getCity = { url: apis + '/zkmsyApi/pig/price/getprovince', method: 'get' }



// 中科基因验证码
reg.websmscode = { url: api + '/user/websmscode/', method: 'get' }
// 中科基因获取IP
reg.userregisterclick = { url: api + '/options/userregisterclick/', method: 'get' }
// 中科基因注册1
reg.smslogin = { url: api + '/user/smslogin/', method: 'postfomdata' }
// 中科基因注册2
reg.websetdevotecode = { url: api + '/options/websetdevotecode/', method: 'postfomdata' }

// 中科名兽医微信分享
live.wxshare = { url: api + '/center/encryption/', method: 'post' }

// 加入我们信息
join.joinus = { url: api + '/zkcoopera/joinus/', method: 'postfomdata' }
// 合作伙伴列表
join.ourpartners = { url: api + '/zkcoopera/ourpartners/', method: 'postfomdata' }

// 聊天历史
chat.chathistory = { url: api + '/advisory/consultonlineinfo/', method: 'postfomdata' }

// 专家详情
expert.expertinfo = { url: api + '/findexpert/expertinfo/', method: 'postfomdata' }
// 专家详情
expert.getExpertDetail = { url: apis + '/custer/common/netWorkHospital/getExpertDetail', method: 'get' }

// 免费课程视频统计
expert.getVideoIncr = { url: apis + '/zkmsyApi/pe/activity/incr', method: 'get' }
// 报名表详情
expert.activityGetSignInfo = { url: apin + '/zkmsy/activity/getSignInfo', method: 'get1' }
// 保存签名
expert.activityEditSignInfo = { url: apin + '/zkmsy/activity/editSignInfo', method: 'posthead' }
// 代付列表
expert.activityPayList = { url: apin + '/zkmsy/activity/common/payList', method: 'post'}
// 确认代付
expert.activityPayConfirm = { url: apin + '/zkmsy/activity/common/payConfirm', method: 'post'}

// 课程概述
expert.getCourseDetail = { url: apis + '/zkmsyApi/pe/course/detail', method: 'get' }
// 获取课程目录信息
expert.getCourseCatalog = { url: apis + '/zkmsyApi/pe/course/catalog', method: 'post' }
// 免费试听
expert.getCourseFree = { url: apis + '/zkmsyApi/pe/course/free', method: 'post' }

// 专家基础信息接口
expertreg.getUserType = { url: api + '/user/gettype/', method: 'get' }
// 专家获取验证码接口
expertreg.getSendCode = { url: apis + '/sso/user/common/sendCode', method: 'post' }
expertreg.getSmsCode = { url: apis + '/sso/user/common/smsCode', method: 'post' }
// 专家登录接口
expertreg.getZkmsyPhonelogin = { url: apis + '/sso/zkmsyUser/common/zkmsyPhonelogin', method: 'post' }
// phython登录接口
expertreg.tokenlogin = { url: api + '/user/tokenlogin/', method: 'post' }
// phython专家注册接口
expertreg.updateexpertinfo = { url: api + '/options/updateexpertinfo/', method: 'postfomdata' }
// 专家注册类型
expertreg.identity = { url: apis + '/zkmsyApi/user/identity', method: 'posthead' }
// phython中科名兽医宣传页计数接口
expertreg.userSweepqrcode = { url: api + '/user/sweepqrcode/', method: 'postfomdata' }

// 首页信息
index.leavingMessageAdd = { url: apis + '/zkmsyApi/message/leavingmessage/add', method: 'post' }
// 话题详情
talk.getTopicDetail = { url: apis + '/zkmsyApi/topic/common/getTopicDetail', method: 'get' }

// 商品详情
talk.goodDetail = { url: apin + '/tianmai-app-api/common/vt/good/detail/general', method: 'post' }

// 商品优惠券
talk.goodEnable = { url: apin + '/tianmai-app-api/coupon/vt/good/enable', method: 'post' }

// 组方详情
talk.compreDetail = { url: apin + '/tianmai-app-api/common/compre/detail', method: 'post' }

// 专家详情
talk.tmgetExpertDetail = { url: apin + '/tianmai-app-api/common/netWorkHospital/getExpertDetail', method: 'get' }

// 禽智养殖
qzyz.pointList = { url: apis + '/fowls/sensor/new/warnv2', method: 'postlogin' }

qzyz.shedList = { url: apis + '/fowls/sensor/shed/warn', method: 'get1' }

// 天气
qzyz.farmWeather = { url: apis + '/fowls/farm/weather', method: 'get1' }

// 巡查详情
qzyz.tourinfo = { url: apis + '/fowls/work/tourinfo', method: 'posturl' }
// 工作详情
qzyz.workinfo = { url: apis + '/fowls/work/workinfo', method: 'posturl' }

/* ------------------------------------发票------------------------------------------- */
inovice.inoviceInfo = { url: apil + '/api/order/get_order_register_info_h5/', method: 'post' }
inovice.getInvoiceTitles = { url: apil + '/api/order/get_invoice_titles/', method: 'post' }
inovice.saveInvoice = {url: apil + '/api/order/save_invoice_info_h5/', method: 'post'}
/* ------------------------------------发票------------------------------------------- */

export { live, test, json, news, reg, chat, join, expert, appkey, wechaturl, expertreg, login, index,talk,qzyz, inovice }

